<template>
  <div v-if="loading">
    <h3>Generating...</h3>
    <div class="buttons is-right">
      <!-- <a class="button is-link is-inverted padded-button next-button">Skip</a> -->
      <a class="button is-link padded-button next-button is-loading" >Continue</a>
    </div>
  </div>
    <div v-else>
    <h3>Doc Generation Failed</h3>
    <p>{{error}}</p>
  </div>
</template>

<script>
export default {
  name: 'DocLoading',
  components: {
  },
  props: {
    loading: Boolean,
    error: String
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted: function () {
    var self = this 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
